import { IconWrapper } from '../runtime';
export default IconWrapper('folder-private-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 20.25C1.00736 20.25 0 19.2426 0 18L0 3C0 1.75736 1.00736 0.75 2.25 0.75L6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3L21.75 3C22.9926 3 24 4.00736 24 5.25L24 18C24 19.2426 22.9926 20.25 21.75 20.25L2.25 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 22.5C1.00736 22.5 0 21.4926 0 20.25L0 7.5C0 6.25736 1.00736 5.25 2.25 5.25L21.75 5.25C22.9926 5.25 24 6.25736 24 7.5L24 20.25C24 21.4926 22.9926 22.5 21.75 22.5L2.25 22.5Z",
      "fill": 'url(#' + props.id + 'cf88098c' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.5 11.4375V12.4688H10.5V11.4375C10.5 10.6091 11.1716 9.9375 12 9.9375C12.8284 9.9375 13.5 10.6091 13.5 11.4375ZM8.625 12.4688H9V11.4375C9 9.78065 10.3431 8.4375 12 8.4375C13.6569 8.4375 15 9.78065 15 11.4375V12.4688H15.375C15.7892 12.4688 16.125 12.8045 16.125 13.2188V17.4375C16.125 17.8517 15.7892 18.1875 15.375 18.1875H8.625C8.21079 18.1875 7.875 17.8517 7.875 17.4375V13.2188C7.875 12.8045 8.21079 12.4688 8.625 12.4688ZM12 14.25C11.6893 14.25 11.4375 14.5018 11.4375 14.8125V16.125C11.4375 16.4357 11.6893 16.6875 12 16.6875C12.3107 16.6875 12.5625 16.4357 12.5625 16.125V14.8125C12.5625 14.5018 12.3107 14.25 12 14.25Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'cf88098c',
      "x1": "2.25",
      "y1": "6.43828",
      "x2": "19.1823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});